import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme';

import { Mouse } from '../../controls/Mouse/Mouse';

interface IProps {
  className?: string;
}

const ZoomInHintBase = (props: IProps) => {
  return (
    <div className={props.className}>
      <Mouse wheel/>
      Zoom in
    </div>
  );
}

const ZoomInHint = styled(ZoomInHintBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export { ZoomInHint }
